import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Spin, Skeleton, Collapse, Table, Tabs, Empty, message } from 'components/shared/AntComponent';
import { Button, Form, Select, Input, InputNumber, TimePicker, DatePicker, TextArea, Radio } from 'components/shared/FormComponent';
import { AssoCandidateList, getExamDetail, saveAssCandidList } from 'services/store/actions/examAction';
import dayjs from 'dayjs';
import { getCourse, getPublicCourse, getSpecialisation } from 'services/store/actions/masterDataAction';

interface ChildProps {
    callbackFunc: (val: any) => void;
    examDetailInfo: any;
    activeTab: any;
    val: any;

}
const AssociateCandidate: React.FC = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('1')
    const { examDetailInfo, loading4 } = useSelector((state: any) => state.exam);
    const examInfo = examDetailInfo?.data?.[0] || null;
    const [candList, setCandList]: any = useState([]);

    const callbackFunc = (val: any) => {
        setCandList(val);
    }

    const slotItems: any = examInfo?.examSlots?.map((item: any, index: number) => ({
        key: (index + 1).toString(),
        label: item.examSlotName,
        children: <AssCandidateFunc val={item} examDetailInfo={examInfo} activeTab={activeTab} callbackFunc={callbackFunc} />
    }))

    const getDetail = () => {
        const id = location?.state?.id + "/" + Number(localStorage.getItem('tenantID'));
        dispatch(getExamDetail(id) as any);
    };

    useEffect(() => {
        if (location?.state?.id !== 0) {
            getDetail();
        }
    }, [location?.state?.id]);

    const goToPreviousScreen = () => {
        navigate('/exam');
    }

    const handleTabChange = (e: any) => {
        setActiveTab(e);
    }

    return (
        <div className="my-3 children-container">
            <div className="px-0 ">
                <div className="row m-0 page-header">
                    <h5 className="my-auto col text-start ps-2 text-secondary fw-bold">
                        {location?.state?.id === 0 ? 'Create Exam' : 'Exam Details'}
                    </h5>
                    <div className="ms-auto col-md-8 text-end my-auto pe-2">
                        <Button type="primary" className="col-auto ms-2 btn-back" onClick={goToPreviousScreen}>
                            Back
                        </Button>
                    </div>
                </div>
            </div>
            <Spin spinning={loading4}>
                <div className="body-content ms-2 me-1 mt-2 row bg-white p-3">
                    <div className="my-auto text-start text-capitalize acc-details-header col">
                        <div className='d-flex w-100'>
                            <div className='col-md-auto border-end'>
                                <p className='text-gray fs-13 mb-1 pe-4'>Exam Name</p>
                                <div className='mb-0 fs-14'>
                                    {loading4 ? <Skeleton.Button active /> : examInfo?.examName || "--"}
                                </div>
                            </div>
                            <div className='col-md-auto border-end px-4'>
                                <p className='text-gray fs-13 mb-1'>College Name</p>
                                <div className='mb-0 fs-14 text-capitalize'>
                                    {loading4 ? <Skeleton.Button active /> : examInfo?.accountName || "--"}
                                </div>
                            </div>
                            <div className='col-md-auto border-end px-4'>
                                <p className='text-gray fs-13 mb-1'>Date of Exam</p>
                                <div className='mb-0 fs-14 text-capitalize'>
                                    {loading4 ? <Skeleton.Button active /> : examInfo?.examDate ? dayjs(examInfo?.examDate).format('DD-MM-YYYY') : "--"}
                                </div>
                            </div>
                            <div className='col-md-auto border-end px-4'>
                                <p className='text-gray fs-13 mb-1'>Duration</p>
                                <div className='mb-0 fs-14 text-capitalize'>
                                    {loading4 ? <Skeleton.Button active /> : examInfo?.examDuration || '--'}
                                </div>
                            </div>
                            <div className='col-md-auto border-end px-4'>
                                <p className='text-gray fs-13 mb-1'>Slots</p>
                                <div className='mb-0 fs-14 text-capitalize'>
                                    {loading4 ? <Skeleton.Button active /> : examInfo?.examSlots?.length || '--'}
                                </div>
                            </div>
                            <div className='col-md-5 border-end px-4'>
                                <p className='text-gray fs-13 mb-1'>Question Template</p>
                                <div className='mb-0 fs-14 text-lowercase'>
                                    {loading4 ? <Skeleton.Button active /> : examInfo?.quesTemplateName || '--'}
                                </div>
                            </div>
                            <div className='col px-4'>
                                <p className='text-gray fs-13 mb-1'>Description</p>
                                <div className='mb-0 fs-14 text-lowercase'>
                                    {loading4 ? <Skeleton.Button active /> : examInfo?.examDescription || '--'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="body-content-height ms-2 me-1 mt-3 row bg-white p-3">
                    <h6 className="my-auto col text-start ps-2 text-secondary fw-bold">
                        {location?.state?.id === 0 ? 'Create Exam' : 'Associate Candidate'}
                    </h6>
                    <Spin spinning={loading4}>
                        <div className='mt-3 ps-1'>
                            <Tabs
                                activeKey={activeTab}
                                items={slotItems}
                                onChange={handleTabChange}
                            />
                        </div>
                    </Spin>
                </div>
            </Spin>
        </div>
    )
}


const AssCandidateFunc: React.FC<ChildProps> = ({ val, examDetailInfo, activeTab, callbackFunc }: any) => {
    const dispatch = useDispatch();
    const {  loading4 } = useSelector((state: any) => state.exam);
    const { loading20, success20, error20 } = useSelector((state: any) => state.exam);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const { loading30, pubCourseInfo, loading12: specLoading, specialisationInfo } = useSelector((state: any) => state.master);
    const { assoCandidList, loading18 } = useSelector((state: any) => state.exam);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success20 : false;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error20 : false;
    const data = !loading18 ? assoCandidList?.data?.data : [];

    const customLocale = {
        emptyText: <Empty className="p-2" description="No Applicant Available" />,
    };

    const courseOptions = useMemo(() =>
        !loading30 && pubCourseInfo?.data?.map((item: any) => ({
            label: item?.courseName,
            value: item?.masCourseID,
            actualID: 0,
        })) || [],
        [loading30, pubCourseInfo]
    );

    const specOptions = useMemo(() =>
        !specLoading && specialisationInfo?.data?.map((item: any) => ({
            value: item?.specializationId,
            label: item?.specializationName,
            id: item?.specializationId,
            description: item.description,
            actualID: 0
        })) || [],
        [specLoading, specialisationInfo]
    );

    const genderOptions: any = useMemo(() => [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "other", label: "Other" }
    ], []);

    function getCourseList() {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getPublicCourse(id) as any);
    }

    function getSpecialisationDetails() {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getSpecialisation(id) as any);
    }

    useEffect(() => {
        getCourseList();
        getSpecialisationDetails();
    }, []);

    const handleSubmit = () => {
        const candidates = selectedRows?.map((item: any) => ({
            "CandExamID": examDetailInfo?.examID,
            "candidateId": item.candidateId,
            "regno": item.regno || "",
            "firstName": item?.firstName || "",
            "middleName": item?.middleName || null,
            "lastName": item?.lastName || "",
            "email": item?.email || "",
            "qualifiedCourseID": item?.qualifiedCourseID || null,
            "qualifiedCourse": item?.qualifiedCourse || "",
            "specializationID": item?.specializationID || null,
            "specializationName": item?.specializationName || "",
            "createdOn": item?.createdOn || "",
            "status": item?.status || "Active",
            "accountId": item?.accountId || null,
            "accountName": item?.accountName || "",
            "tenantId": item?.tenantId || null,
            "preferredField": item?.preferredField || ""
        }))
        const inputJson = {
            "ExamID": examDetailInfo?.examID || "",
            "ExamSlotId": val?.examSlotId,
            "ExamName": examDetailInfo?.examName,
            "ExamDate": examDetailInfo?.examDate ? dayjs(examDetailInfo?.examDate).format('YYYY-MM-DD') : null,
            "DefaultMarks": "1",
            "CandExamStatus": "Active",
            "candidates": candidates || null

        }
        dispatch(saveAssCandidList(inputJson) as any);
        setShowErrormsg(true);
        setShowSuccessmsg(true);
    };
    useEffect(() => {
        if (data?.length > 0) {
            // Check if the `isAssociated` flag is true for each row
            const selectedKeys = data
                .filter((item: any) => item.isAssociated === true)
                .map((item: any) => item.candidateId);

            // Set the selected row keys based on this logic
            setSelectedRowKeys(selectedKeys);
        }

    }, [data]); // Runs when `data` changes
  
    useEffect(() => {
        if (successmsg) {
            message.success('Candidates associated to this exam successfully');
            setShowSuccessmsg(false);
        }
        if (errormsg) {
            if (error20?.message) {
                message.error(error20?.message);
            } else {
                message.error("Candidates couldn't associate with this exam");
            }
            setShowErrormsg(false);
        }
    }, [successmsg, errormsg]);

    const getMatchedLabels = (conditionName: string, assoCondition: string) => {
        if (!conditionName) return "";

        const conditionValues = conditionName.split(',').map(Number);

        let options = [];
        if (assoCondition === "dept") {
            options = specOptions;
        } else if (assoCondition === "course") {
            options = courseOptions;
        } else if (assoCondition === "gender") {
            return conditionName.toLowerCase(); // Return as-is in lowercase for gender
        }

        const matchedLabels = options
            .filter((option: any) => conditionValues.includes(option.value))
            .map((option: any) => option.label?.toLowerCase() || '');

        return matchedLabels.length > 0 ? matchedLabels : conditionName.toLowerCase();
    };

    const getAssociateCandid = () => {
        if (!val || !examDetailInfo) return;

        const matchedLabels = getMatchedLabels(val.conditionName, val.isAssoCondition);

        const inputJson = {
            "InputData": {
                "Status": "Active",
                "AccountId": examDetailInfo.accountId,
                "TenantId": Number(localStorage.getItem('tenantID')),
                "AssoCondition": val.isAssoCondition || "",
                "ConditionName": Array.isArray(matchedLabels) ? val.conditionName?.join(',')?.toLowerCase?.() : val.conditionName?.toLowerCase?.(),
                "ExamId": examDetailInfo?.examID
            },
            "DataFinder": {
                "PageSize": 10,
                "CurrentPage": 1,
                "SortByColumn": "",
                "SortBy": "asc",
                "SearchData": ""
            }
        };
        dispatch(AssoCandidateList(inputJson) as any);
    };

    useEffect(() => {
        // Always fetch when activeTab changes or when options are loaded
        const hasRequiredData =
            examDetailInfo &&
            val &&
            courseOptions.length > 0 &&
            specOptions.length > 0;

        if (hasRequiredData) {
            getAssociateCandid();
        }
    }, [
        activeTab, // This will trigger on tab change
        examDetailInfo?.accountId,
        val?.examSlotId,
        val?.conditionName,
        val?.isAssoCondition,
        courseOptions.length,
        specOptions.length
    ]);

    const columns: any = [
        {
            title: 'Reg No',
            dataIndex: 'regno',
            key: 'regno',
        },
        {
            title: 'First Name',
            dataIndex: 'firstName',
            key: 'firstName',
        },
        {
            title: 'Last Name',
            dataIndex: 'lastName',
            key: 'lastName',
            render: (_: any, record: any) => {
                return (
                    <div>{record?.lastName || "--"}</div>
                )
            }
        },
        {
            title: 'Gender',
            dataIndex: 'gender',
            key: 'gender',
            align: 'center',
        },
        {
            title: 'Mobile No',
            dataIndex: 'mobileNumber',
            key: 'mobileNumber',
            align: 'center',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Course',
            dataIndex: 'qualifiedCourse',
            key: 'qualifiedCourse',
            render: (accountname: any) => {
                return <div>{accountname || '--'}</div>
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
        },
    ];

    const paginationConfig: any = {
        position: ['bottomRight'],
        itemRender: (current: any, type: string, originalElement: any) => {
            if (type === 'prev') {
                return <Button className="prev-btn">Previous</Button>;
            }
            if (type === 'next') {
                return <Button className="next-btn">Next</Button>;
            }
            return originalElement;
        },
    };

    const rowSelection: any = {
        selectedRowKeys,
        onChange: (newSelectedRowKeys: React.Key[], newSelectedRows: any[]) => {
            setSelectedRowKeys(newSelectedRowKeys);
            setSelectedRows(newSelectedRows);   // <-- Store full data
            callbackFunc(newSelectedRows);
        },
        // onChange: onSelectChange,
    };

    const hasSelected = selectedRowKeys.length > 0;

    return (
        <div>
            <div className="custom-table m-2">
                {/* {hasSelected ? `Selected ${selectedRowKeys.length} items` : null} */}
                <Spin spinning={loading18}>
                    <Table
                        rowSelection={rowSelection}
                        columns={columns}
                        className="border"
                        scroll={{ x: 'calc(230px + 50%)' }}
                        dataSource={data}
                        rowKey="candidateId"
                        loading={loading18||loading4}
                        pagination={paginationConfig}
                        locale={customLocale}
                    />
                </Spin>
            </div>
            <div className="text-end">
                <Button type="primary" onClick={handleSubmit} loading={loading20}>Save</Button>
            </div>
        </div>
    )
}

export default AssociateCandidate;